import React, { useState } from 'react';
import { Modal, Button, Form, Table, Dropdown, DropdownButton } from 'react-bootstrap';
import Papa from 'papaparse';
import { auth } from '../../firebase'


const CsvUploadModal = ({ show, handleClose }) => {
  const [csvData, setCsvData] = useState([]);
  const [file, setFile] = useState(null);
  const [roles, setRoles] = useState(['Guest', 'Speaker', 'Sponsor', 'Customer']);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      setFile(file);
      parseCSV(file);
    } else {
      alert('Please upload a valid CSV file');
    }
  };

  const parseCSV = (file) => {
    Papa.parse(file, {
      complete: (result) => {
        const data = result.data.map((row) => ({
          firstName: row[0],
          lastName: row[1],
          email: row[2],
          phoneNumber: row[3],
          category: 'Speaker',
          role: 'Speaker', // Default role is "Speaker"
        }));
        setCsvData(data);
      },
      header: false,
    });
  };

  const handleRoleChange = (index, role) => {
    const updatedData = [...csvData];
    updatedData[index].role = role;
    updatedData[index].category = role;
    setCsvData(updatedData);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload CSV File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formFile">
          <Form.Label>Choose CSV file</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        </Form.Group>

        {csvData.length > 0 && (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {csvData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.email}</td>
                    <td>{item.phoneNumber}</td>
                    <td>
                      <DropdownButton
                        id={`dropdown-role-${index}`}
                        title={item.role}
                        onSelect={(role) => handleRoleChange(index, role)}
                      >
                        {roles.map((role) => (
                          <Dropdown.Item key={role} eventKey={role}>
                            {role}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="success" onClick={()=>{
           if (csvData.length > 0){
               //load it

               auth.currentUser.getIdToken(true).then((idToken) => {

                fetch('https://v2crmaddmemberbyform-650318705789.us-central1.run.app', {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + idToken
      },
      body: JSON.stringify({
        data: csvData,
        category: '',
        merge: false
      })
    }).then((resp) => {
      resp.json().then((data) => {
        if (data.contacts){
          alert("Upload finished: total contacts added: " + data.contacts)
        }
      })
    })
                
                })
               
               

           }

        }}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CsvUploadModal;
